export function confirmer(message, { ok = "Confirmer", annuler = "Annuler", danger = false } = {}) {
  return new Promise((resoudre) => {
    const fond = document.createElement("div");
    fond.setAttribute("data-testid", "confirm-dialog");
    fond.style.cssText = "position:fixed;inset:0;z-index:99999;background:rgba(20,24,28,.45);display:flex;align-items:center;justify-content:center;padding:16px";
    const boite = document.createElement("div");
    boite.style.cssText = "background:#fff;border-radius:14px;max-width:420px;width:100%;padding:18px;box-shadow:0 20px 50px rgba(0,0,0,.25);font-size:14px;line-height:1.5;color:#1d2329";
    const texte = document.createElement("div");
    texte.setAttribute("data-testid", "confirm-dialog-message");
    texte.style.whiteSpace = "pre-line";
    texte.textContent = message;
    const barre = document.createElement("div");
    barre.style.cssText = "display:flex;gap:8px;justify-content:flex-end;margin-top:16px;flex-wrap:wrap";
    const bouton = (libelle, id, style, valeur) => {
      const b = document.createElement("button");
      b.type = "button";
      b.textContent = libelle;
      b.setAttribute("data-testid", id);
      b.style.cssText = "min-height:38px;padding:0 16px;border-radius:10px;font-weight:600;cursor:pointer;" + style;
      b.onclick = () => { fond.remove(); resoudre(valeur); };
      return b;
    };
    barre.append(bouton(annuler, "confirm-dialog-annuler", "background:#fff;border:1px solid #d7d0c3;color:#1d2329", false),
      bouton(ok, "confirm-dialog-ok", `border:0;color:#fff;background:${danger ? "#B42318" : "#0A7A3E"}`, true));
    boite.append(texte, barre);
    fond.append(boite);
    fond.onclick = (e) => { if (e.target === fond) { fond.remove(); resoudre(false); } };
    document.body.append(fond);
  });
}
